import { TokenEndpointOptions, TokenEndpointResponse } from './global';
import { getJSON } from './http';
import { createQueryParams } from './utils';

export async function oauthToken(
  {
    baseUrl,
    timeout,
    audience,
    scope,
    ...options
  }: TokenEndpointOptions,
  worker?: Worker
) {
  const reqbody = createQueryParams(options);

  return await getJSON<TokenEndpointResponse>(
    baseUrl+'/token',
    timeout,
    audience || 'default',
    scope,
    {
      method: 'POST',
      body: reqbody,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json, text/plain, */*'
      }
    },
    worker
  );
}
